import oc from "open-color";
import React, { ReactElement } from "react";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import ContainerWithBorder from "../../components/ContainerWithBorder";
import { FaCircleInfo } from "react-icons/fa6";
import { GiAutoRepair } from "react-icons/gi";

export default function IndicatorBlock({
  onClick,
  isOpen,
  backgroundColor,
  label,
  children,
  tooltipName,
  goToNetLink,
  isMaintenanceDate,
}: {
  onClick: () => void;
  isOpen: boolean;
  backgroundColor: string;
  label: string;
  children: ReactElement;
  tooltipName?: string;
  goToNetLink?: string;
  isMaintenanceDate: boolean;
}): ReactElement {
  if (!backgroundColor.startsWith("#")) {
    const parts = backgroundColor.split(".");
    backgroundColor = (oc as unknown as Record<string, string[]>)[parts[0]][Number(parts[1])];
  }

  return (
    <ContainerWithBorder fillHeight={isOpen}>
      <div
        style={{
          display: "flex",
          padding: "10px 10px",
          backgroundColor,
          fontWeight: "bold",
          color: oc.white,
          cursor: "pointer",
          minWidth: "100%",
          justifyContent: "space-between",
        }}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        title={tooltipName}
      >
        <div style={{ display: "flex" }}>
          <div style={{ marginTop: "-1px", marginRight: "3px" }}>
            {!isOpen ? <IoIosArrowForward size={14} /> : <IoIosArrowDown size={14} />}
          </div>
          <div>{label}</div>
        </div>
        <div style={{ marginTop: "-1px" }}>{isMaintenanceDate && <GiAutoRepair size={18} />}</div>
      </div>

      {isOpen && (
        <>
          {children}
          {goToNetLink && (
            <div style={{ textAlign: "right", padding: "0 15px 15px", marginTop: "-4px" }}>
              <a href={goToNetLink} target="_blank">
                <FaCircleInfo size={16} />
              </a>
            </div>
          )}
        </>
      )}
    </ContainerWithBorder>
  );
}

// export function SmallView({
//   state,
//   changeViewHandler,
//   isSmallView,
// }: {
//   state: VisState<Settings>;
//   changeViewHandler?: (visId: string, show: boolean) => void;
//   isSmallView: boolean;
// }): ReactElement {
//   const deviceid = state.org.getDefaultDeviceId();
//   if (!deviceid) throw new Error("No default device");
//   const device = state.org.devices[deviceid];

//   const aliases = state.org.aliases;

//   const enableIndicationPathArr = (
//     aliases.enableIndication || defaultSettings.aliases.enableIndication
//   )?.split(">");
//   if (!enableIndicationPathArr?.[enableIndicationPathArr.length - 1]) {
//     throw new Error("Enable indication param path not provided.");
//   }

//   const enableParam = enableIndicationPathArr[enableIndicationPathArr.length - 1];
//   const modbusUnitId =
//     Number(enableIndicationPathArr[enableIndicationPathArr.length - 2]) || device.modbusUnitId;
//   const enableIndication = useWatchDeviceRegistersRawData(
//     state.data,
//     state.params,
//     device.netId,
//     modbusUnitId,
//     [["enableIndication", enableParam, state.settings.updatePeriodSec || 60]],
//   );

//   const errorIndicationPathArr = (aliases.mainAlarm || defaultSettings.aliases.mainAlarm)?.split(
//     ">",
//   );
//   if (!errorIndicationPathArr?.[errorIndicationPathArr.length - 1]) {
//     throw new Error("Error indication param path not provided.");
//   }
//   const errorParam = errorIndicationPathArr[errorIndicationPathArr.length - 1];
//   const errorModbusUnitId =
//     Number(errorIndicationPathArr[errorIndicationPathArr.length - 2]) || device.modbusUnitId;
//   const errorndication = useWatchDeviceRegistersRawData(
//     state.data,
//     state.params,
//     device.netId,
//     errorModbusUnitId,
//     [["errorndication", errorParam, state.settings.updatePeriodSec || 60]],
//   );
//   const isMainAlert =
//     errorndication.errorndication !== undefined && Number(errorndication.errorndication) > 0;

//   let pumpBg: string = oc.gray[6];
//   if (enableIndication.enableIndication === undefined) {
//     pumpBg = oc.gray[5];
//   } else if (isMainAlert) {
//     pumpBg = oc.orange[5];
//   } else if (enableIndication.enableIndication === `${state.settings.valueIndForSwitchOn || 1}`) {
//     pumpBg = oc.green[5];
//   } else {
//     pumpBg = oc.red[6];
//   }

//   return (
//     <div
//       style={{
//         display: "flex",
//         padding: "10px 10px",
//         backgroundColor: pumpBg,
//         fontWeight: "bold",
//         color: oc.white,
//         cursor: "pointer",
//         minWidth: "100%",
//       }}
//       onClick={(e) => {
//         e.stopPropagation();
//         const visId = state.visId;
//         visId && changeViewHandler && changeViewHandler(visId, !isSmallView);
//       }}
//     >
//       <div style={{ marginTop: "-1px", marginRight: "3px" }}>
//         {isSmallView ? <IoIosArrowForward size={14} /> : <IoIosArrowDown size={14} />}
//       </div>
//       <div>{state.settings.visName}</div>
//     </div>
//   );
// }
